import { ONBOARDING } from 'constants/Paths';

// App config key controlling whether inactive (TH) customers are locked to /onboarding
// and cannot see any product until their business profile is approved (BV-1886).
export const HIDE_PRODUCT_INACTIVE_CUSTOMER = 'HIDE_PRODUCT_INACTIVE_CUSTOMER';

// Pages a locked customer may still open. Everything else redirects to /onboarding.
const LOCKED_CUSTOMER_ALLOWED_PATHS = [ONBOARDING, '/block-account'];

// Same convention as ALLOW_CHECKOUT: status === 0 => off.
// Missing config (or any other status) => on, so the feature is enabled by default.
export const isHideProductInactiveEnabled = (appConfig = []) => {
  try {
    const item = appConfig?.find((cfg) => cfg?.value?.key === HIDE_PRODUCT_INACTIVE_CUSTOMER);
    return item?.value?.status !== 0;
  } catch {
    return true;
  }
};

export const isInactiveCustomerLocked = (customer, appConfig) =>
  customer?.status === 'INACTIVE' && isHideProductInactiveEnabled(appConfig);

// accepts a pathname or a resolvedUrl (with query string)
export const isPathAllowedForLockedCustomer = (path = '') => {
  const pathname = (path || '').split('?')[0].replace(/\/+$/, '').toLowerCase();
  return LOCKED_CUSTOMER_ALLOWED_PATHS.includes(pathname);
};
